import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alerts } from '@jg/components';
import locationUtils from 'utils/locationUtils/locationUtils';
import Tools from 'utils/tools/tools';
import CobrandedHeader from 'components/CobrandedHeader/CobrandedHeader';
import LandingHero from 'components/LandingHero/LandingHero';
import LandingSteps from 'components/LandingSteps/LandingSteps';
import analytics from 'utils/analytics/analytics';
import { getParticipantEmail, getEventId } from 'selectors/apiSelectors/apiSelectors';
import Immutable from 'immutable';

export class Landing extends React.Component {
  static propTypes = {
    location: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
    isParticipantError: PropTypes.bool.isRequired,
    participantEmail: PropTypes.string,
    eventId: PropTypes.number,
    mainStore: PropTypes.object,
  };

  static defaultProps = {
    location: locationUtils.locationStub,
    isParticipantError: false,
    mainStore: Immutable.fromJS({
      participantPromise: Promise.resolve(),
    }),
  }

  state = {
    isLoading: true,
  }

  componentDidMount() {
    this.props.mainStore.get('participantPromise')
      .then(() => {
        this.firePageView();
        this.setState({ isLoading: false });
      });
  }

  onHeroCTAClick = () => {
    this.onCTAClick('get started');
  }

  onStepsCTAClick = () => {
    this.onCTAClick('ok lets do this');
  }

  onCTAClick(btnText) {
    const { participantEmail, eventId, location } = this.props;
    analytics.track({
      page_type: 'custom project page',
      event: 'link click',
      subtype: 'button',
      event_value: btnText,
      page_section: 'match my miles',
      activity_id: eventId,
      activity_type: 'event_id',
      email: participantEmail,
      actor_id: location.query.guid,
      actor_sources: 'participant guid',
    });

    Tools.scrollToTop();
  }

  firePageView = () => {
    const { participantEmail, eventId, location } = this.props;
    analytics.track({
      page_type: 'custom project page',
      event: 'page view',
      subtype: 'match my miles',
      activity_id: eventId,
      activity_type: 'event_id',
      email: participantEmail,
      actor_id: location.query.guid,
      actor_sources: 'participant guid',
    });
  }

  render() {
    const { location, isParticipantError } = this.props;
    const { isLoading } = this.state;
    return (
      <div className="landing">
        <CobrandedHeader />
        {
          isParticipantError && <Alerts type="error" content="Oops, something went wrong. Please try again later" />
        }
        <LandingHero
          onCTAClick={this.onHeroCTAClick}
          isLoading={isLoading}
          isError={isParticipantError}
          location={location}
        />
        <LandingSteps
          onCTAClick={this.onStepsCTAClick}
          isLoading={isLoading}
          isError={isParticipantError}
          location={location}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mainStore: state.mainStore,
  participantEmail: getParticipantEmail(state),
  eventId: getEventId(state),
  isParticipantError: Boolean(state.mainStore.getIn(['participantRequestError'])),
});

export default connect(mapStateToProps, null)(Landing);



// WEBPACK FOOTER //
// ./layouts/Landing/Landing.js